var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-2"},[_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":_vm.getImage,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }